module.exports = __webpack_public_path__ + "media/images/claim_profile/cp-ff-2dc15aca6d135b04fbc34b111306b0eb.png";